/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { organisationPeek } from '../../axios/organisationPeek'
import type {
	OrganisationPeekError,
	OrganisationPeekPathParams,
	OrganisationPeekResponse,
} from '../../types/OrganisationPeek'

export const organisationPeekQueryKey = (organisation: OrganisationPeekPathParams['organisation']) =>
	[{ url: '/organisations/:organisation/peek', params: { organisation } }] as const

export type OrganisationPeekQueryKey = ReturnType<typeof organisationPeekQueryKey>

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::peek */
export function organisationPeekQueryOptions(
	organisation: OrganisationPeekPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		OrganisationPeekResponse,
		AxiosError<OrganisationPeekError>,
		OrganisationPeekResponse,
		OrganisationPeekQueryKey
	>({
		queryKey: organisationPeekQueryKey(organisation),
		queryFn: ({ signal }) => organisationPeek(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::peek */
export function useOrganisationPeek<TSelectData = OrganisationPeekResponse>(
	organisation: OrganisationPeekPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					OrganisationPeekResponse,
					AxiosError<OrganisationPeekError>,
					TSelectData,
					OrganisationPeekQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<OrganisationPeekError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...organisationPeekQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationController.php OrganisationController::peek */
export function useOrganisationPeekSuspense<TSelectData = OrganisationPeekResponse>(
	organisation: OrganisationPeekPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					OrganisationPeekResponse,
					AxiosError<OrganisationPeekError>,
					TSelectData,
					OrganisationPeekQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<OrganisationPeekError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...organisationPeekQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
